/**
 * Stage Import Configuration
 * All constants and settings for the Stage Import functionality
 */

import { API_config } from './apiConfig';

export const STAGE_IMPORT_CONFIG = {
    // API Endpoints
    get apiUrl() {
        return API_config.dataApiUrl;
    },

    // Allowed sections for stages
    allowedSections: ['TESTOWY', 'LEG 1', 'LEG 2', 'LEG 3', 'LEG 4', 'LEG 5'],

    // Default thin step (1 = keep all points)
    defaultThinStep: 1,

    // List display limit
    listLimit: 200,

    // File upload constraints
    upload: {
        maxSizeBytes: 10 * 1024 * 1024, // 10MB
        allowedExtensions: ['.gpx'],
        allowedMimeTypes: [
            'application/gpx+xml',
            'application/xml',
            'text/xml'
        ]
    },

    // Stage kinds
    stageKinds: {
        OS: 'OS',
        LIAISON: 'LIAISON'
    },

    // Run numbers (sequences)
    runNumbers: [1, 2, 3, 4, 5],

    // GPX source modes
    gpxModes: {
        UPLOAD: 'upload',
        USE_ROAD: 'use_road'
    }
};

export default STAGE_IMPORT_CONFIG;
